//This file is automatically rebuilt by the Cesium build process.
export default "struct czm_ray\n\
{\n\
vec3 origin;\n\
vec3 direction;\n\
};\n\
";
